module.exports = __webpack_public_path__ + "img/carca.ce4bdd47.jpeg";